import React, { Component } from 'react';
import PropTypes from 'prop-types';
import '../styles/hcHomepageStyles.css';
import adobeReaderIcon from '../images/PDF_24.png';
import downloadIcon from '../images/data-transfer-download.svg';
import { FilterButton } from './FilterButton';
import { InfoWidget } from './InfoWidget';
import { ACTIVITY_TYPE } from '../constants/activityTypes';

export class FilterPane extends Component {
    constructor(props) {
        super(props);
        this.buttonStyles = {
            on: {
                background: '#B58DBC',
                color: 'white',
            },
            off: {
                background: 'white',
                color: '#B58DBC',
            },
        };
        this.activityTypes = [ACTIVITY_TYPE.ALL, ACTIVITY_TYPE.AT_HOME, ACTIVITY_TYPE.ON_THE_GO];
        this.state = {
            isOn: [false, false, false],
            buttonStyles: [this.buttonStyles.off, this.buttonStyles.off, 
                this.buttonStyles.off],
        };
    }
    
    componentDidMount() {
        const allActivitiesButtonId = 0;
        this.toggleOn(allActivitiesButtonId, ACTIVITY_TYPE.ALL);
    }

    toggleOn = (buttonId, activityType) => {
        const prevIsOnList = this.state.isOn;
        const prevButtonStyles = this.state.buttonStyles;
        prevIsOnList[buttonId] = true;
        prevButtonStyles[buttonId] = this.buttonStyles.on;
        this.setState({
            isOn: prevIsOnList,
            buttonStyles: prevButtonStyles,
        });
        this.props.addFilter(activityType);
    }

    toggleOff = (buttonId, activityType) => {
        const prevIsOnList = this.state.isOn;
        const prevButtonStyles = this.state.buttonStyles;
        prevIsOnList[buttonId] = false;
        prevButtonStyles[buttonId] = this.buttonStyles.off;
        this.setState({
            isOn: prevIsOnList,
            buttonStyles: prevButtonStyles,
        });
        this.props.removeFilter(activityType);
    }

    handleClick = (buttonId, activityType) => {
        const prevFilter = this.state.isOn.indexOf(true);
        const currentFilter = buttonId;
        
        if (prevFilter !== currentFilter) {
            const toggles = this.state.isOn;
            toggles[buttonId] = true;
            this.setState({
                isOn: toggles,
            });
            
            if (toggles[buttonId]) {
                this.toggleOn(buttonId, activityType);
            }
            this.toggleOff(prevFilter, this.activityTypes[prevFilter]);   
        }
    }
    
    /* TODO: Replace magic numbers */
    render() {
        return (
            <div className="filterPane">
                <span>
                    <span id="skillName">
                        {this.props.skillName}
                    </span>
                    <InfoWidget 
                        customStyle={{ marginTop: 0 }}
                        toolTipText={this.props.toolTipText} 
                    />
                </span>
                <button id="pdfButton">
                    <a
                        href={this.props.pdfURL}
                        target="__blank"
                    >
                        <img
                            src={adobeReaderIcon}
                            alt="Adobe Reader" />
                                &nbsp;&nbsp;
                                PDF
                                &nbsp;&nbsp;
                        <img
                            src={downloadIcon}
                            alt="Download Icon" />
                    </a>
                </button>
                <div className="navPane">
                    <FilterButton
                        buttonId={0}
                        filterButtonType={ACTIVITY_TYPE.ALL}
                        filterButtonName={this.props.filterButtonText.allActivities}
                        handleClick={this.handleClick}
                        style={this.state.buttonStyles[0]}
                    />
                    <FilterButton
                        buttonId={1}
                        filterButtonType={ACTIVITY_TYPE.AT_HOME}
                        filterButtonName={this.props.filterButtonText.atHome}
                        handleClick={this.handleClick}
                        style={this.state.buttonStyles[1]}
                    />
                    <FilterButton
                        buttonId={2}
                        filterButtonType={ACTIVITY_TYPE.ON_THE_GO}
                        filterButtonName={this.props.filterButtonText.onTheGo}
                        handleClick={this.handleClick}
                        style={this.state.buttonStyles[2]}
                    />
                </div>
            </div>
        );
    }
}

FilterPane.propTypes = {
    filterButtonText: PropTypes.object.isRequired,
    toolTipText: PropTypes.string.isRequired,
    skillName: PropTypes.string.isRequired,
    addFilter: PropTypes.func.isRequired,
    removeFilter: PropTypes.func.isRequired,
    pdfURL: PropTypes.string.isRequired,
};

export default FilterPane;



// WEBPACK FOOTER //
// ./src/components/FilterPane.jsx